import "./DateInput.scss";
import moment from "moment";
export default {
  name: "DateInput",
  data: () => ({
    dateModel: "",
    menuModel: false,
    formatedDate: "",
    timeModel: "",
    dirty: false,
    touched: false
  }),
  mounted() {
    this.initializeDateModels();
  },
  methods: {
    validate() {
      this.dirty = true;
      return this.errorMessages.length === 0;
    },
    updateValue: function(value) {
      value = value.trim();
      const momentValue = this.useUTC ? moment.utc(value) : moment(value);
      this.formatedDate = momentValue?.format(this.format) ?? "";
      let momentObj = moment(value);
      if (this.overwriteTime) {
        let { [0]: hour, [1]: minute } = this.overwriteTime.split(":");
        momentObj.set({ hour, minute });
      }
      this.$emit("input", value ? momentObj.toISOString() : "");
    },
    initializeDateModels() {
      this.dateModel = moment(this.value).format("YYYY-MM-DD");
      this.timeModel = moment(this.value).format("HH:mm");
      this.formatedDate = moment(this.value).format(this.format);
      if (this.dateModel.includes("Invalid")) {
        this.dateModel = "";
        this.timeModel = "";
        this.formatedDate = "";
      }
    },
    applyDate() {
      this.dirty = true;
      this.fillDefault();
      this.updateValue(this.dateModel + " " + this.timeModel);
      this.menuModel = false;
    },
    resetDate() {
      this.dirty = true;
      this.dateModel = "";
      this.timeModel = "";
      this.formatedDate = "";
      this.updateValue("");
      this.menuModel = false;
    },
    fillDefault() {
      if (!this.dateModel) this.dateModel = moment().format("YYYY-MM-DD");
      if (!this.timeModel) {
        if (this.dateTime) {
          // default time if time-picker is active
          this.timeModel = "12:00";
        } else {
          // no time-picker. use 03:00 to prevent unintentional 'day before selection' on first input (timezone hour shifting)
          this.timeModel = "03:00";
        }
      }
    },
    onFieldBlur() {
      if (this.touched && !this.menuModel) {
        this.dirty = true;
      }
    }
  },
  computed: {
    errorMessages() {
      if (!this.dirty) return [];
      const messages = [];
      for (const rule of this.rules) {
        const result = typeof rule === "function" ? rule(this.value) : rule;
        if (result !== true && result !== "") {
          messages.push(result || "");
        }
      }
      return messages;
    },
    hasError() {
      return !!this.error || this.errorMessages.length > 0;
    },
    formattedDateDisplay: {
      get() {
        if (this.dateModel) {
          return moment(this.dateModel).format("DD.MM.YYYY");
        }
        return "";
      },
      set(value) {
        const parsed = moment(value, "DD.MM.YYYY", true);
        if (parsed.isValid()) {
          this.dateModel = parsed.format("YYYY-MM-DD");
        }
      }
    }
  },
  watch: {
    value: function() {
      this.initializeDateModels();
    },
    menuModel: function(val) {
      if (!val && this.touched) {
        this.dirty = true;
      }
    },
    dateModel: function(val) {
      if (val) {
        this.fillDefault();
        this.updateValue(this.dateModel + " " + this.timeModel);
      }
    },
    timeModel: function() {
      if (this.dateModel) {
        this.fillDefault();
        this.updateValue(this.dateModel + " " + this.timeModel);
      }
    }
  },
  props: {
    value: {
      type: [String, Date],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: "DD.MM.YYYY"
    },
    dateTime: {
      type: Boolean,
      default: false
    },
    overwriteTime: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    appendIcon: {
      type: String,
      default: null
    },
    useUTC: {
      type: Boolean,
      default: true
    },
    error: {},
    allowedDatesFunc: {
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    }
  }
};
